module.exports = __webpack_public_path__ + "static/media/prizes_en.2d2a57a7.png";